import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import validate from './validation'
import * as ContentActions from '../../../../actions/content'
import { ChannelsFormExtra } from '../../../../components/Screens'
import { channels as channelsFormProps } from '../../../../types'
import { ObjectUtils } from '../../../../utils'
import ChannelsForm from '../../../../components/Screens/Content/Forms/Channels'
import PromosForm from '../../../../components/Screens/Content/Forms/Promo/Promos'
import { promoForm as promoFormProps } from '../../../../types'
import { ContentTypes } from '../../../../constants'
import * as SocketActions from '../../../../actions/socket'
import * as DeviceActions from '../../../../actions/device'
import { Types as DeviceTypes } from '../../../../actions/device'
import * as NotificationActions from '../../../../actions/notifications'

class Channels extends PureComponent {
    static propTypes = {
        editFormValue: PropTypes.func.isRequired,
        editForm: PropTypes.func.isRequired,
        form: PropTypes.shape(channelsFormProps).isRequired,
        promoForm: PropTypes.shape(promoFormProps).isRequired,
        channel: PropTypes.shape(channelsFormProps),
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool.isRequired,
        updateChannel: PropTypes.func.isRequired,
        fetchMedia: PropTypes.func.isRequired,
        media: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        promo: PropTypes.arrayOf(PropTypes.shape({})),
        uploadMedia: PropTypes.func.isRequired,
        selectedChannel: PropTypes.shape({}),
        t: PropTypes.func.isRequired,
        reloadPromo: PropTypes.func.isRequired,
        resetForm: PropTypes.func.isRequired,
        notify: PropTypes.func.isRequired,
    }

    static defaultProps = {
        isOpen: false,
        channel: null,
    }

    constructor(props) {
        const { channel, editForm } = props

        super(props)

        this.state = {
            formErrors: {
                name: null,
                date_start: null,
                date_end: null,
                slug: null,
                synced: null,
                channel_extra: null,
                chain_id: null,
            },
            modalIsOpen: false,
            uploadMediaModalIsOpen: false,
            progress: 0,
            isWorking: false,
        }

        this.onChangeFormValue = this.onChangeFormValue.bind(this)
        this.onChangeSynced = this.onChangeSynced.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onCloseFormChannels = this.onCloseFormChannels.bind(this)
        this.onFinishSubmitChannels = this.onFinishSubmitChannels.bind(this)
        this.onChangeChannel = this.onChangeChannel.bind(this)
        this.onDropPromo = this.onDropPromo.bind(this)
        this.inputToFocus = React.createRef()

        if (channel) {
            editForm('editChannel', channel)
        }
    }

    componentDidUpdate(prevProps) {
        const { channel, editForm, isOpen } = this.props
        const { isOpen: prevIsOpen } = prevProps

        if (channel && isOpen && isOpen !== prevIsOpen) {
            editForm('editChannel', channel)
        }
    }

    componentDidMount() {
        this.loadData()
    }

    onChangeFormValue({ target: { name, value } }) {
        const { editFormValue } = this.props
        editFormValue('editChannel', { name, value })
    }

    onChangeSynced() {
        const {
            editFormValue,
            form: { synced },
        } = this.props
        const value = synced ? 0 : 1
        editFormValue('editChannel', { name: 'synced', value })
    }

    onChangeChainId = (chainValue) => {
        const { editFormValue } = this.props
        editFormValue('editChain', { name: 'chain_id', value: chainValue })
    }

    async onSubmit(e) {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        if (!this.validate()) {
            return
        }

        const { form, updateChannel, editForm, channel } = this.props
        const response = await updateChannel(form.id, form)
        if (response.type === 'UPDATE_CHANNEL##SUCCESS') {
            editForm('editChannel', response.payload)
        } else editForm('editChannel', channel)
        this.setState({ modalIsOpen: false })
    }

    buildOnchangeObject() {
        return {
            name: this.onChangeFormValue,
            date_start: (value) => this.onChangeFormValue({ target: { name: 'date_start', value } }),
            date_end: (value) => this.onChangeFormValue({ target: { name: 'date_end', value } }),
            slug: this.onChangeFormValue,
            channel_extra: this.onChangeFormValue,
            synced: this.onChangeSynced,
            chain_id: (value) => this.onChangeFormValue({ target: { name: 'chain_id', value } }),
        }
    }

    /**
     * Form Validation
     */
    validate() {
        const { form } = this.props
        const formErrors = validate(form)
        this.setState({ formErrors })
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    /**
     * On close channels form
     */
    onCloseFormChannels() {
        this.setState({ modalIsOpen: false })
    }

    async onChangeChannel(channel) {
        const { deselectChannel } = this.props

        deselectChannel()
    }

    /**
     * Once all the new channel has been stored, we attach it to the playlist
     * @param {Array} storedActionsArray Redux action from upload
     * @async
     */
    async onFinishSubmitChannels(storedAction) {
        const { form, editForm } = this.props

        if (storedAction.type === 'UPDATE_CHANNEL##SUCCESS') {
            editForm('editChannel', storedAction.payload)
        } else editForm('editChannel', storedAction.payload)
        form.name = storedAction.payload.name
        const {
            payload: { id: channelID, name: searchChannel },
        } = storedAction
        this.setState({ modalIsOpen: false, searchChannel }, () => this.onChangeChannel(channelID))
    }

    onProgress = (progress) => {
        this.setState({ progress })
    }

    loadData() {
        const { resetUpload } = this.props
        resetUpload(ContentTypes.MEDIA)
        this.setState({ progress: 0 })
    }

    /**
     * On drag and drop media
     * @param {Object} media
     */
    async onDropPromo(media) {
        const { selectedChannel, updateChannel } = this.props
        const { id: channelID } = selectedChannel

        await updateChannel(channelID, {
            ...selectedChannel,
            media,
        })
    }

    restart = async (uid, withNotification = false) => {
        const { reloadPromo, notify } = this.props
        const response = await reloadPromo(uid)
        if (withNotification)
            if (response.type === DeviceTypes.API_PROMO_RELOAD_FAILURE) {
                notify({ title: 'Error', body: `Update device ${uid} with new promos failed` })
            } else if (response.type === DeviceTypes.API_RELOAD_PROMOS_SUCCESS) {
                notify({ title: 'Succeed', body: `Update device ${uid} with new promos succeed ` })
            }
    }

    render() {
        const { form, isOpen, isWorking, t, channel, media, promoForm, selectedChannel, resetForm } = this.props
        const { formErrors, modalIsOpen, uploadMediaModalIsOpen } = this.state

        return (
            <>
                <ChannelsFormExtra
                    onOpenSettings={() => {
                        this.setState({ modalIsOpen: true })
                    }}
                    onOpenUploadMedia={() => {
                        const { fetchMedia } = this.props
                        fetchMedia(null)
                        this.setState({ uploadMediaModalIsOpen: true })
                    }}
                    ref={this.inputToFocus}
                    errors={formErrors}
                    isOpen={isOpen}
                    isWorking={isWorking}
                    onChangeForm={this.buildOnchangeObject()}
                    onClickSubmit={this.onSubmit}
                    values={form}
                    enablePromo={selectedChannel?.promo_enabled}
                    t={t}
                />
                <ChannelsForm
                    channelId={channel.id}
                    initialChannel={channel}
                    onChangeForm={this.buildOnchangeObject()}
                    isOpenForEdit
                    values={form}
                    t={t}
                    isOpen={modalIsOpen}
                    onClickCancel={this.onCloseFormChannels}
                    onFinishSubmit={this.onFinishSubmitChannels}
                    onClickSubmit={this.onSubmit}
                />
                <PromosForm
                    channelId={channel.id}
                    channelName={channel.name}
                    promoForm={promoForm}
                    t={t}
                    isOpen={uploadMediaModalIsOpen}
                    onClickSubmit={() => resetForm()}
                    onClickCancel={() => this.setState({ uploadMediaModalIsOpen: false })}
                    media={media}
                    onDropMedia={this.onDropPromo}
                    reloadPromo={this.restart}
                    devices={selectedChannel?.devices}
                />
            </>
        )
    }
}

const mapStateToProps = ({
    content: {
        isWorking: { channels: isWorking },
        form: { editChannel: form },
        form: { promo: promoForm },
        media,
        selected: { channels: selectedChannel },
    },
}) => ({
    form,
    promoForm,
    isWorking,
    media,
    selectedChannel,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
            ...SocketActions,
            reloadPromo: DeviceActions.reloadPromosViaAPI,
            ...NotificationActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Channels))
